import { render, staticRenderFns } from "./BaseFormGroupInputDate.vue?vue&type=template&id=d08bcb76"
import script from "./BaseFormGroupInputDate.vue?vue&type=script&lang=js"
export * from "./BaseFormGroupInputDate.vue?vue&type=script&lang=js"
import style0 from "./BaseFormGroupInputDate.vue?vue&type=style&index=0&id=d08bcb76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports